<template>
  <h-msg-box
    v-model="showModal"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">移出队伍确认</span>
    </p>
    <p class="model-text">
      是否确认将队员<span>{{ title }}</span
      >移出队伍
    </p>
    <div slot="footer">
      <comp-button type="default" @click="showModal = false"
        >不移出</comp-button
      >
      <comp-button @click="remove">移出</comp-button>
    </div>
  </h-msg-box>
</template>

<script>
import { CompButton } from '../common'
import Api from '@/api/competition/financialIndex'
import { mapState } from 'vuex'

export default {
  name: 'RemoveTeamMate',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false,
      title: ''
    }
  },
  components: {
    CompButton
  },
  computed: {
    ...mapState({ delMate: (state) => state.financialCompetition.delMate })
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    remove() {
      Api.deleteCompetTeamEmp(this.delMate.hsid).then(
        ({ error_code, error_info }) => {
          if (error_code === '0') {
            this.showModal = false
            this.$hMessage.success('移除成功')
          } else {
            this.$hMessage.error(error_info)
          }
        },
        (err) => {
          this.$hMessage.error('移除失败')
        }
      )
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
      this.title = `${this.delMate.emp_name}`
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.model-header {
  font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 24px;
}
.model-text {
  text-align: center;
  font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 14px;
  color: #333333;
  line-height: 32px;
  span {
    color: #ffa64d;
  }
}
</style>







// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/MyTeam/RemoveTeamMate.vue